import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';

import { camelCaseTransformer } from '@sondermind/utilities/tools';
import { ISelfPayRateItem, SelfPayVisitType } from '../models/self-pay-rates.interface';

@Injectable({
  providedIn: 'root',
})
export class SelfPayRatesHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getSelfPayRates$(
    visitType: SelfPayVisitType,
    opts: Partial<IAPIListRequestOptions> = {}
  ): Observable<ISelfPayRateItem[]> {
    const params = this.http.generateListParams(opts).set('visit_type', visitType);

    return this.http.get<IAPIListResponse<ISelfPayRateItem>>(this.fetchUrl(), params).pipe(
      map((resp) => camelCaseTransformer<ISelfPayRateItem[]>(resp.data)),
      this.http.handleHttpError(opts.error)
    );
  }

  private fetchUrl(): string {
    return `${this.configurationService.env.svcBase}/billing/rates/self_pay_rates`;
  }
}
